import {
  cardBase,
  homeColors,
  linkButtonReset,
  sectionLabel,
} from '../../tokens'

const styles = () => ({
  root: {
    ...cardBase,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '22px 24px',
  },
  label: {
    ...sectionLabel,
    margin: 0,
  },
  list: {
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  // The whole row is clickable.
  link: {
    ...linkButtonReset,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: 'calc(100% + 16px)',
    margin: '0 -8px',
    padding: '6px 8px',
    borderRadius: '10px',
    fontSize: '15px',
    color: homeColors.ink,
    '&:hover': {
      background: homeColors.hover,
      '& $linkLabel': {
        color: homeColors.primary,
      },
    },
  },
  icon: {
    width: 32,
    height: 32,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
  },
  iconGlyph: {
    width: 18,
    height: 18,
  },
  linkLabel: {
    flex: 1,
    minWidth: 0,
  },
  footerLink: {
    ...linkButtonReset,
    marginTop: '4px',
    fontSize: '15px',
    fontWeight: 600,
    color: homeColors.primary,
  },
})

export default styles
